import { put, takeEvery, select } from 'redux-saga/effects';

import actionCreators from './actionCreators';
import actionTypes from './actionTypes';
import defaults from './defaults';
import selectors from './selectors';

// INDIVIDUAL SAGAS
export function* validateDraftDetailsUsingDraftYear() {
    const { draftYear } = yield select(selectors.getFilterValues);

    if (draftYear !== 'undrafted') {
        return;
    }

    yield put(actionCreators.resetFilter('draftRound', defaults.values.draftRound));
}

// WATCHERS
function* watchDraftYear() {
    yield takeEvery(actionTypes.SET_DRAFT_YEAR, validateDraftDetailsUsingDraftYear);
}

// EXPORT / OUTSIDE INTERFACE
export default {
    watchDraftYear: watchDraftYear(),
};
